import AddToCartMutation from 'assets/graphql/mutations/AddToCartMutation.graphql';
import CartQuery from 'assets/graphql/queries/Cart.graphql';

import { sendOrderMutation } from 'common/services/utils/utmTracker';

/**
 * Input for `AddToCartMutation` variables
 * @typedef {Object} AddToCartInput
 * @property {string} boxId
 * @property {string} activityId
 * @property {number} quantity
 * @property {boolean} isGroup
 * @property {string} source
 * @property {string} boxType
 * @property {string} sellingSpotId
 * @property {string} kindId
 * @property {string} campaignSlug
 * @property {string} landingSlug
 */

/**
 * @typedef {Object} AddToCartMutationResponse
 * @property {boolean} ok
 * @property {(Array|undefined)} errors
 * @property {(string|undefined)} redirect_url
 */

/**
 * Adds an item to cart
 * @param {AddToCartInput} input
 * @param {*} apollo - usually `this.$apollo`
 * @returns {AddToCartMutationResponse}
 */
export const addToCartService = async (input, apollo) => {
  let order = null;
  try {
    const cartResponse = await apollo.query({
      query: CartQuery,
    });
    order = cartResponse.data.cart;
  } catch (e) {
    // eslint-disable-next-line
    console.error('Could not get order', e);
    return {
      ok: false,
      errors: [e],
    };
  }

  let retObj = {};
  try {
    const response = await apollo.mutate({
      mutation: AddToCartMutation,
      variables: input,
    });
    retObj = response.data.update_cart_item;
  } catch (e) {
    // eslint-disable-next-line
    console.error('Could not update cart', e);
    return {
      ok: false,
      errors: [e],
    };
  }

  if (!order) {
    try {
      await sendOrderMutation(retObj.order.id, apollo);
    } catch (e) {
      // eslint-disable-next-line
      console.warn('Could not set utm values to order', e);
    }
  }

  return retObj;
};
